var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.769,
    height: 21.717,
    viewBox: "0 0 23.769 21.717",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3632",
    "data-name": "Group 3632",
    transform: "translate(10 -0.501)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2984",
    "data-name": "Path 2984",
    d: "M110.615,3.236a4.3,4.3,0,0,1,1.015-1.608,3.974,3.974,0,0,1,6.251.929c.957,1.742,1.972,3.446,2.958,5.169,1.646,2.862,3.312,5.724,4.939,8.6a3.957,3.957,0,1,1-6.921,3.839q-2.168-3.776-4.346-7.543a.864.864,0,0,0-.105-.153,1.559,1.559,0,0,1-.316-.469c-.641-1.13-1.3-2.25-1.943-3.369-.412-.728-.842-1.445-1.254-2.173a3.964,3.964,0,0,1-.526-2.106,2.935,2.935,0,0,1,.249-1.11",
    transform: "translate(-112.527 0)",
    fill: "#2377be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2985",
    "data-name": "Path 2985",
    d: "M11.828,42.493a5.5,5.5,0,0,0-.182,1.053,4.136,4.136,0,0,0,.574,2.25q1.579,2.714,3.149,5.447c.1.163.172.325.268.479-.574,1-1.149,1.981-1.733,2.977-.8,1.388-1.608,2.786-2.422,4.174-.038,0-.048-.019-.057-.048a.593.593,0,0,1,.038-.22,3.853,3.853,0,0,0-.919-3.8A3.648,3.648,0,0,0,8.3,53.645a3.885,3.885,0,0,0-3.073.852c-.163.124-.268.306-.459.4a.064.064,0,0,1-.067-.048c.459-.795.909-1.589,1.369-2.384q2.843-4.939,5.7-9.869c.019-.038.048-.067.067-.105",
    transform: "translate(-13.739 -39.257)",
    fill: "#fcab00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2986",
    "data-name": "Path 2986",
    d: "M-9,213.592c.182-.163.354-.335.546-.488a3.957,3.957,0,0,1,6.327,2.4,4.208,4.208,0,0,1-.153,2.039,1,1,0,0,1-.038.163c-.086.153-.163.316-.258.469a3.849,3.849,0,0,1-3.752,2,3.93,3.93,0,0,1-3.628-3.427,3.831,3.831,0,0,1,.526-2.546c.1-.172.211-.326.316-.5.048-.038.029-.115.115-.115",
    transform: "translate(0 -197.969)",
    fill: "#3d993c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdsIcon);
export default __webpack_public_path__ + "static/media/adsIcon.9f08ba79.svg";
export { ForwardRef as ReactComponent };